export default "__VITE_ASSET__IZq6lyIO__"